// extracted by mini-css-extract-plugin
module.exports = {"message":"OutageStatus__message___qTrMt","warningPanel":"OutageStatus__warningPanel___30xBG","warningIcon":"OutageStatus__warningIcon___3EJ7L"};